import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-697b5a7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-fanhui" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import {ref, watch, onMounted, nextTick} from 'vue';
import {Tabs, Tab} from 'vant';
import TitleBar from '@/components/TitleBar.vue';
import {useAllList} from '@/service/info';
import {closeWindow, reportLog} from '@/bridge/index';
import {useDeviceInfo} from '@/hooks/useDeviceInfo';
import {haboClickReport} from '@/plugins/haboConfig';
import {useTagInfo} from '@/hooks/useTagInfo';
import {ANI_TIME, TAB_KEY_MAP} from '@/enum/constant';
import useTimeReport from '@/hooks/useTimeReport';
import {useNPSPopup} from '@/hooks/useNPSPopup';
import TabContent from './TabContent/index.vue';


const __default__ = {
  name: 'Info',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

_useCssVars(_ctx => ({
  "4207295e": (showTabsWrapVisibility.value)
}))

const {h5CmsCategoryList} = useTagInfo();
const {statusBarHeight} = useDeviceInfo();
useTimeReport('SELECT_INFO_STAY_TIME');
onMounted(() => {
  haboClickReport('INFO_PAGE_EXPOSURE', {});
});
const back = useNPSPopup();

const initTagId = ref<number>(TAB_KEY_MAP.all);
const tabActive = ref<number>(TAB_KEY_MAP.all);

// 记录已经渲染过的 tab. 控制每个 tab 下的内容初次渲染, 因为 swiperable 的 tab 默认会加载出所有 tab 下的内容
const renderedTabArr = ref<number[]>([]);
const pushRenderedTab = (tabId: number) => {
  renderedTabArr.value.push(tabId);
};

// 记录第一次渲染的状态, 第一次渲染仅请求当前 active 的 tab. 这么处理是因为组件库会把前面的无关 tab 数据也请求
const animateDuration = ref<number>(ANI_TIME);
watch(tabActive, (curTab: number, preTab: number) => {
  // 根据 tab 切换设置动画时长
  // 不会出现找不到 -1 的情况
  const curTabIndex = tabObjList.value.findIndex(item => item.tagId === curTab);
  const preTabIndex = tabObjList.value.findIndex(item => item.tagId === preTab);
  if (Math.abs(curTabIndex - preTabIndex) > 1) {
    animateDuration.value = 0;
  }
  else {
    animateDuration.value = ANI_TIME;
  }
});

const initTabObjList = h5CmsCategoryList.map(item => ({
  tagId: item,
  tagName: '...'
}));
initTabObjList.length > 1 && initTabObjList.unshift({tagId: TAB_KEY_MAP.all, tagName: '全部'});
initTabObjList.push({tagId: TAB_KEY_MAP.collect, tagName: '收藏'});
const tabObjList = ref<{
  tagId: number;
  tagName: string;
}[]>(initTabObjList);

const handleTabClick = (tabInfo: { name: number; title: string }) => {
  const {name: id, title} = tabInfo;// name 是标签 id, title 为标签名
  const tagIndex = tabObjList.value.findIndex(item => item.tagId === id);
  if (id === TAB_KEY_MAP.collect) {
    haboClickReport('COLLECT_TAB_CLICK', {});
    return;
  }
  haboClickReport('CMS_TAG_CLICK', {
    label_name: title,
    label_idx: tagIndex,
  });
};

// 请求标签信息, 和资讯品类名(展示 titlebar 标题)
const {
  data: tagList,
  execute: refetchTagList,
  isFinished,
  error,
} = useAllList(
  {
    current: 1,
    pageSize: 1
  },
  {
    newsCategoryIds: h5CmsCategoryList,
  },
  'selectTag',
  true
);

// 如果标签请求错误, 需要重新请求标签
const ifRefetchTagList = () => {
  if (error.value) {
    refetchTagList();
  }
};

// tab 标题区域是否显示
const showTabsWrapVisibility = ref<string>('hidden');
watch(isFinished, () => {
  if (isFinished.value && !error.value) {
    const list = tagList.value?.list?.[0]?.h5CmsCategoryList.map(item => ({
      tagId: item.newsCategoryId,
      tagName: item.newsCategoryName
    })) ?? [];
    showTabsWrapVisibility.value = 'visible';
    if (list.length > 1) {
      list.unshift({tagId: TAB_KEY_MAP.all, tagName: '全部'});
    }
    list.push({tagId: TAB_KEY_MAP.collect, tagName: '收藏'});
    tabObjList.value = list;
    haboClickReport('CMS_TAG_EXPOSURE', {
      label_names: `[${list.map(item => item.tagName).toString()}]`
    });
    nextTick(() => {
      reportLog('fmp');
    });
  }
});

onMounted(() => {
  haboClickReport('SELECT_INFO_VIEW');
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TitleBar, {
      title: "资讯",
      "notice-bar-height": _unref(statusBarHeight)
    }, {
      left: _withCtx(() => [
        (_openBlock(), _createElementBlock("svg", {
          class: "icon back-icon",
          "aria-hidden": "true",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(back) && _unref(back)(...args)))
        }, _hoisted_3))
      ]),
      _: 1
    }, 8, ["notice-bar-height"]),
    _createVNode(_unref(Tabs), {
      active: tabActive.value,
      "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((tabActive).value = $event)),
      "line-height": 3,
      "line-width": 16,
      ellipsis: false,
      duration: animateDuration.value,
      "lazy-render": "",
      swipeable: "",
      shrink: "",
      onClickTab: handleTabClick
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabObjList.value, (item) => {
          return (_openBlock(), _createBlock(_unref(Tab), {
            key: item.tagId,
            title: item.tagName,
            name: item.tagId
          }, {
            default: _withCtx(() => [
              (renderedTabArr.value.includes(item.tagId) || item.tagId === tabActive.value)
                ? (_openBlock(), _createBlock(TabContent, {
                    key: 0,
                    "tab-id": item.tagId,
                    "if-refetch-tag-list": ifRefetchTagList,
                    "tag-list-finished": _unref(isFinished),
                    "push-rendered-tab": pushRenderedTab,
                    "use-native": item.tagId === initTagId.value
                  }, null, 8, ["tab-id", "tag-list-finished", "use-native"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["title", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["active", "duration"])
  ]))
}
}

})